import GeoJsonObject from 'src/services/geoJson/GeoJsonObject';

export default class GeoJsonSource extends GeoJsonObject {}
